
import { Grid } from '@mui/material';
import { withStyles } from '@mui/styles';
import React, { Component, useEffect } from 'react';
import { useTranslation, withTranslation } from 'react-i18next';
import CustomizedCircularProgress from '../../components/CustomCircularProgress';
import CustomDrawer from '../../components/CustomDrawer';

//card test: 378282246310005

// class ProcessFormView extends Component {
//     componentDidUpdate() {
//         let paymentForm = document.forms['paymentForm'];
//         if(paymentForm){
//           paymentForm.submit()
//         }
//     }

//     render() {
//         const { t, html_content } = this.props;
//         console.log("AAAA ProcessFormView props: ", this.props)
//         return (
//             <div>
//                 <CustomDrawer
//                     open={this.props.open}
//                     onClose={() => this.props.onClose()}
//                     title={t('Process')}
//                     enableBack
//                 >
//                     <div style={{ width: '100%' }} dangerouslySetInnerHTML={{ __html: html_content }} />
//                     <Grid xs={12} item container justify='center'><CustomizedCircularProgress /></Grid>
//                 </CustomDrawer>
//             </div>
//         );
//     }
// }

// const styles = theme => ({

// });

// export default withStyles(styles)(withTranslation()(ProcessFormView));

export default function ProcessFormView(props) {
    const { html_content } = props;
    const { t } = useTranslation();

    useEffect(() => {
        const timer = setTimeout(() => {
            const form = document.forms['paymentForm'];
            if (form) form.submit();
        }, 0);

        return () => clearTimeout(timer);
    }, [html_content]);

    return (
        <div>
            <CustomDrawer
                open={props.open}
                onClose={() => props.onClose()}
                title={t('Process')}
                enableBack
            >
                <div style={{ width: '100%' }} dangerouslySetInnerHTML={{ __html: html_content }} />
                <Grid xs={12} item container justify='center'><CustomizedCircularProgress /></Grid>
            </CustomDrawer>
        </div>
    );
}